import { useStore } from "@/stores/cashRegister";
import CashRegister from "@/types/CashRegister";
import { defineComponent, PropType, computed } from "vue";
import Multiselect from "../General/Multiselect.vue";

export default defineComponent({
  props: {
    cash_registers: {
      type: Object as PropType<CashRegister[]>,
      required: true,
    }
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const cashRegisterStore = useStore();

    cashRegisterStore.initFromStorage();

    const value = computed({
      get: (): CashRegister | null => cashRegisterStore.selected,
      set: (v: CashRegister | null) => cashRegisterStore.select(v),
    });

    return {
      value
    };
  },
  components: { Multiselect }
});
